import {FJModalAction, FJCloudAction} from './FJRoot.action';
import FJLocalStore from '../../store/FJLocalStore';
import FJActionConstant from "../../constant/FJActionConstant";
import FJCanvasStore from "../../store/FJCanvasStore";
import FJSaveStore from "../../store/FJSaveStore";
import FJUtil from "../../util/FJUtil";
import FJCloudStore from "../../store/FJCloudStore";

let FJSaveAction = (function () {
  return {
    /**
     * @description 显示退出保存的模态框
     * @returns {Function}
     */
    showExitSaveModalAction: function (callback) {
      return (dispatch) => {
        let data = {
          headerText: FJLocalStore._('save-project-title'),
          bodyText: FJLocalStore._('save-project-content'),
          cancelType: 'cancel',
          cancelText: FJLocalStore._('dont-save'),
          submitText: FJLocalStore._('save'),
          isDistinguishCancel: true,
          onCancel: (hide) => {
            hide();
          },
          onSubmit: (hide) => {
            hide();
            callback('save');
          },
          onClickOther: (hide) =>{
            hide();
            callback('continue');
          }
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      }
    },

    /**
     * @description 显示保存失败的弹窗
     * @returns {Function}
     */
    showSaveFailModalAction: function () {
      return (dispatch) => {
        let data = {
          headerText: FJLocalStore._('sorry'),
          bodyText: FJLocalStore._('fail-save-project'),
          onCancel: null,
          cancelType: 'cancel',
          onSubmit: (callback) => {
            callback();
            FJCanvasStore.executeSync(FJCanvasStore.command.SAVE_FOR_ONLINE);
          },
          submitText: FJLocalStore._('retry')
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      }
    },

    /**
     * @description 设置保存按钮的PopoverType显示类型
     * @param data
     * @returns {{data: *, type: string}}
     */
    setShowPopoverTypeAction: function (data) {
      return {
        type: FJActionConstant.SET_SHOW_POPOVER_TYPE,
        data
      }
    },

    /**
     * @default 设置是否在匿名登录中
     * @param {boolean} value
     * @return {{type: string, value: *}}
     */
    setAnonymousStatusAction: function (value) {
      return {
        type: FJActionConstant.SET_ANONYMOUS_SAVE_STATUS,
        value,
      }
    },

    /**
     * @description 判断是否有为保存的工程内容
     * @param callback
     * @returns {Function}
     */
    checkIsSaveAction: function (callback) {
      return (dispatch, getState) => {
        let {SAVED, SAVE} = FJSaveStore.SAVE_STATUS;
        const state = getState();
        let { failed} = state.cloud;
        let func = (type) => {
          switch (type) {
            case 'continue':
              window.onbeforeunload = () => {};
              callback(true);
              break;
            case 'save':
              if (SAVE === FJSaveStore.status) {
                FJUtil.doSave();
              }
              break;
          }
        };

        if (SAVED !== FJSaveStore.status) {
          dispatch(this.showExitSaveModalAction(func));
        } else if (failed.length > 0 || FJCloudStore.getUploadingMedia()) {
          dispatch(FJCloudAction.showCloudSyncingModal(func));
        } else {
          func('continue');
        }
      }
    }
  }
})();

export default FJSaveAction;
